module.exports = __webpack_public_path__ + "img/menu-logout.d4b7615a.svg";